(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/ticket-partner/assets/react/pages/digital-tickets/components/login-register/login-register.js') >= 0) return;  svs.modules.push('/modules/ticket-partner/assets/react/pages/digital-tickets/components/login-register/login-register.js');
"use strict";

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }

const _svs$ticket_partner$c = svs.ticket_partner.constants.routes,
  PASSWORD_RECOVERY = _svs$ticket_partner$c.PASSWORD_RECOVERY,
  DIGITAL_TICKETS = _svs$ticket_partner$c.DIGITAL_TICKETS;
const Link = svs.app.ReactRouter.Link;
const Email = svs.ui.reactFormInputs.EmailInput;
const TextInput = svs.ui.reactFormInputs.TextInput;
const _svs$ui$reactForm = svs.ui.reactForm,
  Form = _svs$ui$reactForm.Form,
  ControlGroup = _svs$ui$reactForm.ControlGroup;
const _React = React,
  useState = _React.useState;
const _svs$ui$ReactGrid = svs.ui.ReactGrid,
  Grid = _svs$ui$ReactGrid.Grid,
  GridRow = _svs$ui$ReactGrid.GridRow,
  GridCol = _svs$ui$ReactGrid.GridCol;
const _svs$ticket_partner$d = svs.ticket_partner.digitalTickets.loginRegister.constants.FORMS.EMAIL,
  EMAIL_LABEL = _svs$ticket_partner$d.EMAIL_LABEL,
  EMAIL_MAX = _svs$ticket_partner$d.EMAIL_MAX,
  EMAIL_REQUIRED_ERROR = _svs$ticket_partner$d.EMAIL_REQUIRED_ERROR,
  EMAIL_NAME = _svs$ticket_partner$d.EMAIL_NAME;
const _svs$ticket_partner$d2 = svs.ticket_partner.digitalTickets.loginRegister.constants.FORMS.PASSWORD,
  PASSWORD_LABEL = _svs$ticket_partner$d2.PASSWORD_LABEL,
  PASSWORD_NAME = _svs$ticket_partner$d2.PASSWORD_NAME,
  PASSWORD_REQUIRED_ERROR = _svs$ticket_partner$d2.PASSWORD_REQUIRED_ERROR;
const Button = svs.ui.ReactButton;
const _svs$ticket_partner$d3 = svs.ticket_partner.digitalTickets.loginRegister.constants.FORMS,
  LOGIN_HEADER = _svs$ticket_partner$d3.LOGIN_HEADER,
  LOGIN_INGRESS = _svs$ticket_partner$d3.LOGIN_INGRESS,
  LOGIN_REGISTER = _svs$ticket_partner$d3.LOGIN_REGISTER,
  PASSWORD_LINK = _svs$ticket_partner$d3.PASSWORD_LINK,
  LOGIN_CREATE_ACCOUNT = _svs$ticket_partner$d3.LOGIN_CREATE_ACCOUNT;
const Login = () => {
  const _svs$ticket_partner$s = svs.ticket_partner.sharedComponents.hooks.useBreakpointGreaterThan('sm'),
    _svs$ticket_partner$s2 = _slicedToArray(_svs$ticket_partner$s, 1),
    isLarge = _svs$ticket_partner$s2[0];
  const _svs$ticket_partner$u = svs.ticket_partner.useUserContext(),
    login = _svs$ticket_partner$u.login;
  const _useState = useState(''),
    _useState2 = _slicedToArray(_useState, 2),
    email = _useState2[0],
    setEmail = _useState2[1];
  const _useState3 = useState(''),
    _useState4 = _slicedToArray(_useState3, 2),
    password = _useState4[0],
    setPassword = _useState4[1];
  const handleSubmit = async (e, formData) => {
    e && e.preventDefault();
    if (_.values(formData).filter(field => !field.isValid).length === 0) {
      svs.ui.loader.show();
      await login(email, password);
      svs.ui.loader.hide();
    }
  };
  return React.createElement(Form, {
    onSubmit: handleSubmit
  }, React.createElement("h2", {
    className: "f-bold u-text-left"
  }, LOGIN_HEADER), React.createElement("span", {
    className: "u-text-left"
  }, LOGIN_INGRESS), React.createElement(GridRow, null, React.createElement(GridCol, {
    am: {
      col: 5
    },
    sm: {
      col: 12
    }
  }, React.createElement(Email, {
    errorMessageRequired: EMAIL_REQUIRED_ERROR,
    id: EMAIL_NAME,
    isRequired: true,
    label: EMAIL_LABEL,
    max: EMAIL_MAX,
    name: EMAIL_NAME,
    onChange: e => setEmail(e.target.value),
    value: email
  })), React.createElement(GridCol, {
    am: {
      col: 5
    },
    sm: {
      col: 12
    }
  }, React.createElement(TextInput, {
    errorMessageRequired: PASSWORD_REQUIRED_ERROR,
    id: PASSWORD_NAME,
    isRequired: true,
    label: PASSWORD_LABEL,
    name: PASSWORD_NAME,
    onChange: e => setPassword(e.target.value),
    type: "password",
    value: password
  })), React.createElement(GridCol, {
    am: {
      col: 2
    },
    className: "u-text-center",
    sm: {
      col: 12
    }
  }, React.createElement(ControlGroup, {
    v2: true
  }, React.createElement(Button, {
    block: isLarge,
    className: !isLarge ? 'button-width-150' : '',
    inverted: true,
    type: "submit"
  }, "Logga in")))), React.createElement(GridRow, null, React.createElement("div", {
    className: "padding-top-2 ".concat(isLarge ? 'u-text-right' : 'u-text-center')
  }, React.createElement(Link, {
    to: "".concat(PASSWORD_RECOVERY, "?returnUrl=").concat(DIGITAL_TICKETS)
  }, PASSWORD_LINK))));
};
const RegisterNewCustomer = _ref => {
  let handleNewCustomer = _ref.handleNewCustomer;
  const _svs$ticket_partner$s3 = svs.ticket_partner.sharedComponents.hooks.useBreakpointGreaterThan('sm'),
    _svs$ticket_partner$s4 = _slicedToArray(_svs$ticket_partner$s3, 1),
    isLarge = _svs$ticket_partner$s4[0];
  return React.createElement(GridRow, null, React.createElement("h2", {
    className: "f-bold u-text-left"
  }, LOGIN_REGISTER, ' '), React.createElement(GridCol, {
    am: {
      col: 10
    },
    className: "u-text-left u-flex u-flex-align-items-center",
    sm: {
      col: 12
    }
  }, "Slutf\xF6r din best\xE4llning och skapa ditt f\xF6retagskonto p\xE5 samma g\xE5ng."), React.createElement(GridCol, {
    am: {
      col: 2
    },
    className: "u-text-center",
    sm: {
      col: 12
    }
  }, React.createElement(Button, {
    block: isLarge,
    className: !isLarge ? 'button-width-150' : '',
    inverted: true,
    onClick: handleNewCustomer
  }, LOGIN_CREATE_ACCOUNT)));
};
const LoginRegister = _ref2 => {
  let handleNewCustomer = _ref2.handleNewCustomer;
  return React.createElement(Grid, null, React.createElement(Login, null), React.createElement(RegisterNewCustomer, {
    handleNewCustomer: handleNewCustomer
  }));
};
svs.ticket_partner.digitalTickets.loginRegister.LoginRegister = LoginRegister;

 })(window);